
import { count } from './_count.js';
import { trimAll } from './../String/_string.js';

// helpers ---------------------------------------------------------------------

function fleschFormula(wordSentencesCount, syllablesWordsCount) {
  return 206.835 - 1.015*wordSentencesCount - 84.6*syllablesWordsCount;
}

function fleschFormulaNew(params) {
  // todo - flesh simplified - more on wiki: https://en.wikipedia.org/wiki/Readability#The_Flesch_formulas
  // Publishers discovered that the Flesch formulas could increase readership up to 60 percent. Flesch's work also made an enormous impact on journalism. The Flesch Reading Ease formula became one of the most widely-used, tested, and reliable readability metrics.[40][41] In 1951, Farr, Jenkins, and Patterson simplified the formula further by changing the syllable count. The modified formula is:

  // New reading ease score = 1.599nosw − 1.015sl − 31.517
  // Where: nosw = number of one-syllable words per 100 words and
  // sl = average sentence length in words
}

function fleschKincaidGrade(wordSentencesCount, syllablesWordsCount) {
  return 0.39*wordSentencesCount + 11.8*syllablesWordsCount - 15.59;
}

function automatedReadabilityFormula(charsWordsCount, wordSentencesCount) {
  // based on https://en.wikipedia.org/wiki/Automated_readability_index
  return 4.71 * charsWordsCount + 0.5 * wordSentencesCount - 21.43;
}

// todo: check if it works for czech
function numDaleChallDifficultWords(freshText) {
  var text = trimAll(freshText).toLowerCase();
  text = text.replace(/[^A-Za-z\-\s']+/g, "");

  let daleChallList = [];
  var wordArray = text.split(" ");
  for(var i = 0; i < wordArray.length; i++) {
    for(var j = 0; j < daleChallList.length; j++) {
      if(wordArray[i] === daleChallList[j] || (wordArray[i]) === (daleChallList[j]+"s")) {
        wordArray.splice(i, 1);
        i--;
      }
    }
  }

  return wordArray.length;
}

function daleChallFormula(freshText, wordsCount, wordSentencesCount) {
  const difficultWordsPct = (numDaleChallDifficultWords(freshText)/wordsCount)*100;

  let daleChall = 0.1579*difficultWordsPct+0.0496*(wordSentencesCount);
  if(difficultWordsPct > 5) daleChall += 3.6365;

  return daleChall;
}

function gunningFogFormula(wordSentencesCount, gunningHardWords, wordsCount) {
  return 0.4*(wordSentencesCount + 100*(gunningHardWords/wordsCount));
}

function FORECASTformula(singleSyllablesCount, wordsCount) {
  const singleSyllablesWordsPer150 = singleSyllablesCount/(wordsCount/150);
  return 20 - (singleSyllablesWordsPer150/10);  
}

function readabilityFormula(fleschKincaidGradeLevel, charsCount, _histogram) {

  const expectedReaderLevel = 8;
  let readability = (1 / (fleschKincaidGradeLevel / expectedReaderLevel)) * 100;

  // easing - short text will ease the function
  let easingSmall = 0;
  if (charsCount < 20) {
    easingSmall = (20-charsCount)*100/20;
  }

  if (charsCount < 20) {
    readability = (readability + easingSmall) / 1 + 1*easingSmall;
  }

  if (readability > 300) readability = 300;
  
  if (_histogram) {
    for (let index = 0; index < _histogram.length; index++) {
      const hItem = _histogram[index];
      if (hItem.overPct) readability = readability - hItem.cpct;
    }
  }

  if (readability > 100) readability = 100;
  if (readability < 0) readability = 0;

  return readability;
}

// readability tests -----------------------------------------------------------
function readabilityTests(freshText, _stats, _locales, _histogram) {
  const output = {};

  console.time("readability");

  let fleschReadingEase = 0;
  let fleschKincaidGradeLevel = 0;
  let daleChall = 0;
  let gunningFogGradeLevel = 0;
  let FORECASTGradeLevel = 0;
  let readability = 100;

  // only works with alpha letters - completely omit when user starts writing 1234
  const alphaLeters = count.onlyLetters(freshText);
  if(alphaLeters > 0) {

    // performance - reused
    const {totalSyllables, gunningHardWords, singleSyllablesCount} = count.syllablesCzech(freshText);

    const allCharsCount = _stats.charsAll;
    const charsCount = _stats.chars;
    const wordsCount = _stats.words;
    const sentencesCount = _stats.sentences;
    const wordSentencesCount = count.wordsPerSentence(wordsCount, sentencesCount);
    const syllablesWordsCount = totalSyllables/wordsCount;

    // Flesch formulas
    fleschReadingEase = fleschFormula(wordSentencesCount, syllablesWordsCount);
    fleschKincaidGradeLevel = fleschKincaidGrade(wordSentencesCount, syllablesWordsCount);
    
    // Dale Chall formula
    daleChall = daleChallFormula(freshText, wordsCount, wordSentencesCount)
    
    // Gunning fog
    gunningFogGradeLevel = gunningFogFormula(wordSentencesCount, gunningHardWords, wordsCount);

    // FORECAST
    FORECASTGradeLevel = FORECASTformula(singleSyllablesCount, wordsCount);

    // todo: rework - more performant, separated from others
    readability = readabilityFormula(fleschKincaidGradeLevel, allCharsCount, _histogram);
  }

  // prepare for return
  output.fleschReadingEase = fleschReadingEase.toLocaleString(_locales, {maximumFractionDigits: 2});
  output.fleschKincaidGradeLevel = fleschKincaidGradeLevel.toLocaleString(_locales, {maximumFractionDigits: 2});
  output.daleChall = daleChall.toLocaleString(_locales, {maximumFractionDigits: 2});
  output.gunningFogGradeLevel = gunningFogGradeLevel.toLocaleString(_locales, {maximumFractionDigits: 2});
  output.FORECASTGradeLevel = FORECASTGradeLevel.toLocaleString(_locales, {maximumFractionDigits: 2});
  
  // todo rework - more performant, separated from others
  output.readability = readability.toLocaleString(_locales, {maximumFractionDigits: 2}) + " %";

  console.timeEnd("readability");
  return output;
}

export { readabilityTests }